import { WidgetArticleGalleryContent, resolveFilePath } from 'jamespot-user-api';
import React from 'react';
import styled from 'styled-components';

import { JRCWidgetImage } from '../JRCWidgetImage/JRCWidgetImage';

const CSSGallery = styled.div<{ width: number | string }>`
    width: ${(props) => props.width}px;
    position: relative;
`;

const CSSGalleryColumn = styled.div<{ column: string; gap: string }>`
    column-count: ${(props) => props.column};
    gap: ${(props) => props.gap}px;
`;

const CSSGalleryColumnImage = styled.div<{ width: number; height: number; gap: string }>`
    display: flex;
    width: ${(props) => props.width}px;
    height: auto;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: ${(props) => props.gap}px;
    position: relative;

    .hover {
        opacity: 0;
        background: rgba(255, 255, 255, 0.4);
    }
    .hover.on {
        opacity: 1;
    }
`;

export const JRCWidgetArticleGallery = ({
    files,
    size = 'fitx1200',
    gap,
    column,
    maxWidth = 800,
    onClick,
}: WidgetArticleGalleryContent & { maxWidth: number; size?: string; onClick: (idFile: number) => void }) => {
    const ref = React.useRef<HTMLHeadingElement>(null);

    const resolveWidth = (count: string, gap: string, maxWidth: number): number => {
        return (maxWidth - (int(count) - 1) * int(gap)) / int(count);
    };

    return files ? (
        <CSSGallery ref={ref} width={maxWidth}>
            <CSSGalleryColumn column={column ?? '3'} gap={gap !== undefined ? gap : '10'}>
                {files.map((file, index: number) => {
                    const width = resolveWidth(column ? column : '3', gap ? gap : '4', maxWidth);
                    return (
                        <CSSGalleryColumnImage
                            onClick={() => onClick(file.id)}
                            key={index}
                            width={width}
                            gap={gap !== undefined ? gap : '10'}
                            height={0}>
                            <JRCWidgetImage uri={file.path ?? resolveFilePath(file, size)} maxWidth={width} />
                            <div
                                id={`image-${file.id}`}
                                className={'hover'}
                                style={{ position: 'absolute', inset: 0 }}></div>
                        </CSSGalleryColumnImage>
                    );
                })}
            </CSSGalleryColumn>
        </CSSGallery>
    ) : (
        <></>
    );
};

function int(str: string): number {
    return parseInt(str);
}
